/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_USER_TYPES, GET_USER_TYPES } from 'src/actions/userTypeActions';

const initialState = {
  userTypes: [],
  isFetching: false,
  message: ''
};

const userTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_USER_TYPES: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_USER_TYPES: {
      const { userTypes, message } = action.payload;

      return produce(state, (draft) => {
        draft.userTypes = userTypes;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default userTypeReducer;
